import { memo } from "react";

import { Finding } from "stores/FindingStore";

import FindingDetailsRow from "components/FindingDetailsRow";

import Abstract from "./Abstract";

// -----------------------------------------------------------------------------

const OrganizationFindingDetailsRow = memo(
  function OrganizationFindingDetailsRow({
    finding,
  }: OrganizationFindingDetailsRowProps): JSX.Element {
    return (
      <Abstract label="Details">
        <FindingDetailsRow finding={finding} />
      </Abstract>
    );
  }
);

export default OrganizationFindingDetailsRow;

// -----------------------------------------------------------------------------

interface OrganizationFindingDetailsRowProps {
  finding: Finding;
}
